<div (click)="onClick($event)">
  <se-fe-modal *ngIf="showModal" #editPersonaModal [seFeDataActions]="editPersonaButtons" (seFeAfterClose)="onAfterClose()">
    <div seFeModalHeader>
      <se-fe-modal-header
        seFeDataTitle="Edit {{ profile?.persona?.first_name }}'s Profile">
      </se-fe-modal-header>
    </div>
    <div seFeModalContent class="modal-content">
      <se-po-edit-persona #editInfo
        [profile]="profile"
        [requiredFields]="requiredFields"
        [showContactInfo]="showContactInfo"
      ></se-po-edit-persona>
    </div>
  </se-fe-modal>
</div>
<se-fe-toast></se-fe-toast>
